import { render } from "./KarussellRestaurant3.vue?vue&type=template&id=4ee2d55d"
import script from "./KarussellRestaurant3.vue?vue&type=script&lang=js"
export * from "./KarussellRestaurant3.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__